import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthProvider';
import { isSuper, canDo } from '../utils/canDo';

const SAADHAK_PATHS = ['/SaadhakDashboard', '/MyReports', '/MyConsultations', '/Notifications'];
const UNIVERSAL_PATHS = ['/MyDocuments', '/ChangePassword', '/TherapistDashboard', '/ListPatients'];

const PrivateRoute = ({ permission, altPermission }) => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();

  if (!auth?.roles) {
    return <Navigate to="/login" replace />;
  }

  // 1. Super roles (owner/solution) always pass
  if (isSuper(auth)) return <Outlet />;

  // 2. Saadhak users — fixed screens only
  if (auth.roles.includes('saadhak')) {
    if (SAADHAK_PATHS.includes(location.pathname)) return <Outlet />;
    if (UNIVERSAL_PATHS.includes(location.pathname)) return <Outlet />;
    return <Navigate to="/SaadhakDashboard" replace />;
  }

  // 3. Universal paths — all authenticated users
  if (UNIVERSAL_PATHS.includes(location.pathname)) return <Outlet />;

  // 4. Per-user screen access
  const hasScreenAccess = Array.isArray(auth.allowedScreens) &&
    auth.allowedScreens.includes(location.pathname);

  // 5. Per-user permission (primary or alternate)
  const hasPermission = (permission && canDo(auth, permission)) ||
    (altPermission && canDo(auth, altPermission));

  if (hasScreenAccess || hasPermission) return <Outlet />;

  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
